<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>分红池</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formBody">
        <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" prop="id" label="序列号" width="120">
            </el-table-column>
            <el-table-column align="center" prop="level" label="等级" width="150">
                <template slot-scope="scope">
                    <span>{{ scope.row.level == 100?'沉淀':scope.row.level }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="hasAmount" label="剩余分红数量" min-width="100">
            </el-table-column>
        </el-table>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        userData: [],
        editTwoFormVisible: false,
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        newShowData:[]
      }
    },
    // 注册组件
    components: {
      
    },
    created() {
    },
    methods: {
     
    }
  }
  </script>
  
  <style scoped>
  .formBody{
    margin-top: 40px;
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/adminSet/levelHave.vue